import "./index.css";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProdWaterUsage from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import waterIcon from "../../../../../assets/new-product-detail-cats/sub-icons/product-water-usage-icon.svg";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import ProdSubBox from "../../components/SubcategoryBox/";
import { useState } from "react";

const ProdWaterUsageContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const [selectedMethod, setSelectedMethod] = useState("emission_factor"); // 'emission_factor' or 'invoice'
  const shouldShowTable = isPDFMode || showTable;

  const handleMethodChange = (method) => {
    setSelectedMethod(method);
  };

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("WATER_USAGE_INFO")}
        subDescription={t("WATER_USAGE_DESC")}
        isNormal={true}
        number={"11.3"}
        icon={waterIcon}
      />

      {/* Method Selection Buttons */}
      <div className="method-selection">
        <button
          className={`method-button ${
            selectedMethod === "invoice" ? "active" : ""
          }`}
          onClick={() => handleMethodChange("invoice")}
        >
          {t("IF_YOU_HAVE_INVOICES")} (Flow 11.3.1)
        </button>

        <button
          className={`method-button ${
            selectedMethod === "emission_factor" ? "active" : ""
          }`}
          onClick={() => handleMethodChange("emission_factor")}
        >
          {t("IF_YOU_HAVE_SPECIFIC_EMISSION_FACTOR_DATA")} (Flow 11.3.2)
        </button>
      </div>

      {/* Flow 11.3.2: Emission Factor Method */}
      {selectedMethod === "emission_factor" && (
        <div>
          <ProdSubBox
            title={t("IF_YOU_HAVE_SPECIFIC_EMISSION_FACTOR_DATA")}
            desc={t("WATER_USAGE_EMISSION_FACTOR_INSTRUCTION")}
          />
          {shouldShowTable && (
            <TableLoadingWrapper
              tableId={`prod-waterusage-emission-${productId}`}
              minLoadTime={3000}
              maxLoadTime={20000}
            >
              <ProdWaterUsage
                productId={productId}
                method="emission_factor"
                key={`emission-${productId}`}
              />
            </TableLoadingWrapper>
          )}
          <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
        </div>
      )}

      {/* Flow 11.3.1: Invoice Method */}
      {selectedMethod === "invoice" && (
        <div>
          <ProdSubBox
            title={t("IF_YOU_HAVE_INVOICES")}
            desc={t("WATER_USAGE_INVOICE_INSTRUCTION")}
          />
          {shouldShowTable && (
            <TableLoadingWrapper
              tableId={`prod-waterusage-invoice-${productId}`}
              minLoadTime={3000}
              maxLoadTime={20000}
            >
              <ProdWaterUsage
                productId={productId}
                method="invoice"
                key={`invoice-${productId}`}
              />
            </TableLoadingWrapper>
          )}
          <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
        </div>
      )}
    </div>
  );
};

export default ProdWaterUsageContents;
